<!-- Must have content text, default only show close button -->
<script>
  import {
    showGlobalNotificationModal,
    globalNotificationModalDetails,
  } from "../../stores";
  import NotificationModal from "./NotificationModal.svelte";

  const closeModal = () => {
    $globalNotificationModalDetails = {};
    $showGlobalNotificationModal = false;
  };
</script>

{#if $showGlobalNotificationModal}
  <NotificationModal
    isModalOpen={$showGlobalNotificationModal}
    title={$globalNotificationModalDetails.title}
    showCancelBtn={$globalNotificationModalDetails.showCancelBtn ?? true}
    showConfirmBtn={$globalNotificationModalDetails.showConfirmBtn ?? false}
    closeModalFunction={closeModal}
    {closeModal}
  >
    {$globalNotificationModalDetails.contentText}
  </NotificationModal>
{/if}
